import React from 'react';
import PropTypes from 'prop-types';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const ConfirmationMessage = ({ errorMessage }) => (
  <Stack alignItems="center" spacing={2} sx={{ mb: 6, mt: 4, mx: 3 }}>
    {errorMessage ? (
      <>
        <HighlightOffIcon
          sx={{
            color: 'error.main',
            fontSize: '71px',
            mb: 2,
          }}
        />
        <Typography align="center" variant="body1">
          Due to an error, a nomination could not be created: {errorMessage}
        </Typography>
      </>
    ) : (
      <>
        <CheckRoundedIcon
          sx={{
            color: 'secondary.main',
            fontSize: '71px',
            mb: 2,
          }}
        />
        <Typography variant="h6">Success!</Typography>
        <Typography align="center" variant="body1">
          New Monthly Nomination created successfully. Review the details below.
        </Typography>
      </>
    )}
  </Stack>
);

ConfirmationMessage.propTypes = {
  errorMessage: PropTypes.string.isRequired,
};

export default ConfirmationMessage;
